export const en = {
    'get-backgrounds-error': 'Error happened trying to get page backgrounds',
    title: 'Select background',
    'update-error': 'An error happened trying to update background'
};
